import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

/** Counter Bleed — full-bleed counter photo; mark lives in nav/footer, not above eyebrow. */
export const heroCounterBleedDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.heroCounterBleed,
  componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
  registryBlockKey: REGISTRY_BLOCK.presentation.heroCounterBleed,
  displayOrder: 1,
  content: {
    eyebrow: loc3('Sushi-Bar · Berlin', 'Sushi bar · Berlin', 'Quầy sushi · Berlin'),
    heading: loc3(
      'Präzision an der Theke',
      'Precision at the counter',
      'Độ chính xác tại quầy',
    ),
    subheading: loc3(
      'Nigiri, Tagesfang und Omakase — ruhig, kurz, im Blick des Itamae.',
      'Nigiri, day catch, and omakase — calm, short, in the itamae’s eye.',
      'Nigiri, cá theo ngày và omakase — yên, ngắn, trong tầm mắt itamae.',
    ),
    ctaPrimary: loc3('Speisekarte ansehen', 'View menu', 'Xem thực đơn'),
  },
  media: {
    heroImage: '/platform/defaults/heroes/restaurant/sushi-bar-on-dark-01.jpg',
  },
};
